import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './index.css';

const renderInitials = ({ firstName = '', lastName = '' }) => {
  let str = '';
  str += firstName.charAt(0);
  str += lastName.charAt(0);
  return str.toUpperCase();
};

const InitialsBubble = ({ userInfo, className }) => (
  <div className={classnames('initials-bubble', className)}>
    {userInfo && renderInitials(userInfo)}
  </div>
);

InitialsBubble.propTypes = {
  className: PropTypes.string,
  userInfo: PropTypes.object.isRequired,
};

export default InitialsBubble;



// WEBPACK FOOTER //
// ./src/common/components/InitialsBubble/index.js